import { render, staticRenderFns } from "./SwiperWrapper.vue?vue&type=template&id=d4c0f99c&scoped=true&"
import script from "./SwiperWrapper.vue?vue&type=script&lang=js&"
export * from "./SwiperWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SwiperWrapper.vue?vue&type=style&index=0&id=d4c0f99c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c0f99c",
  null
  
)

export default component.exports